module.exports = __webpack_public_path__ + "img/kulioner-was-buy.cb3ab175.svg";